import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { imagesTimeActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchImagesTime, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchImagesTime({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchImagesTime } = this.props
    fetchImagesTime()
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchImagesTime, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchImagesTime, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = imageTime => {
    const { fetchImageTime, deleteImageTime, addConfirm, token, restoreImageTime } = this.props

    return (
      <Fragment>
        {readOnly('imagens_minutos', token) &&
          !imageTime.deletedAt && (
            <IconButton
              onClick={() => {
                fetchImageTime(imageTime._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!imageTime.deletedAt && findPermission('imagens_minutos', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste tempo?',
                confirmFunction: () => {
                  restoreImageTime(imageTime._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('imagens_minutos', token).editar && (
              <IconButton
                onClick={() => {
                  fetchImageTime(imageTime._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('imagens_minutos', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste tempo?',
                    confirmFunction: () => {
                      deleteImageTime(imageTime._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, imagesTime = [], loadingImagesTime, pagination, order = {} } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingImagesTime && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Nome
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'tempo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('tempo')
                  }}
                >
                  Tempo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(imagesTime || []).length ? (
              (imagesTime || []).map(imageTime => {
                return (
                  <TableRow key={imageTime._id}>
                    <TableRowColumn>{imageTime.nome}</TableRowColumn>
                    <TableRowColumn>{imageTime.tempo}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(imageTime)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingImagesTime ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    imageTime: state.imagesTime.imageTime,
    imagesTime: state.imagesTime.imagesTime,
    loadingImagesTime: state.imagesTime.loadingImagesTime,
    token: state.auth.token,
    pagination: state.imagesTime.imagesTimePagination,
    order: state.imagesTime.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(imagesTimeActions.openModal())
    },
    closeModal: () => {
      dispatch(imagesTimeActions.closeModal())
    },
    fetchImageTime: id => {
      dispatch(imagesTimeActions.fetchImageTime(id))
    },
    fetchImagesTime: options => {
      dispatch(imagesTimeActions.fetchImagesTime(options))
    },
    deleteImageTime: id => {
      dispatch(imagesTimeActions.deleteImageTime(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(imagesTimeActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(imagesTimeActions.handleChangePerPage(perPage))
    },
    restoreImageTime: id => {
      dispatch(imagesTimeActions.restoreImageTime(id))
    },
    changeOrderColumn: column => {
      dispatch(imagesTimeActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(imagesTimeActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/ImagesTime/ListTable.js